module.exports = __webpack_public_path__ + "img/new_tool_omega_vertical.3c1774f2.png";